module.exports = __webpack_public_path__ + "img/pr-6.6adf946c.png";